import { createRouter, createWebHashHistory } from 'vue-router';
import StartStep from '@/components/steps/StartStep.vue';
import HausStep1 from '@/components/steps/haus/HausStep1.vue';
import HausStep2 from '@/components/steps/haus/HausStep2.vue';
import HausStep3 from '@/components/steps/haus/HausStep3.vue';
import HausStep4 from '@/components/steps/haus/HausStep4.vue';
import HausStep5 from '@/components/steps/haus/HausStep5.vue';
import HausStep6 from '@/components/steps/haus/HausStep6.vue';
import HausStep7 from '@/components/steps/haus/HausStep7.vue';
import HausStep8a from '@/components/steps/haus/HausStep8a.vue';
import HausStep8b from '@/components/steps/haus/HausStep8b.vue';
import HausStep9 from '@/components/steps/haus/HausStep9.vue';
import HausStep10 from '@/components/steps/haus/HausStep10.vue';
import HausStep11a from '@/components/steps/haus/HausStep11a.vue';
import HausStep11b from '@/components/steps/haus/HausStep11b.vue';
import HausStep11c from '@/components/steps/haus/HausStep11c.vue';
import WohnungStep1 from '@/components/steps/wohnung/WohnungStep1.vue';
import WohnungStep2 from '@/components/steps/wohnung/WohnungStep2.vue';
import WohnungStep3 from '@/components/steps/wohnung/WohnungStep3.vue';
import WohnungStep4 from '@/components/steps/wohnung/WohnungStep4.vue';
import WohnungStep5 from '@/components/steps/wohnung/WohnungStep5.vue';
import WohnungStep6 from '@/components/steps/wohnung/WohnungStep6.vue';
import WohnungStep7 from '@/components/steps/wohnung/WohnungStep7.vue';
import WohnungStep8a from '@/components/steps/wohnung/WohnungStep8a.vue';
import WohnungStep8b from '@/components/steps/wohnung/WohnungStep8b.vue';

import WohnungStep9 from '@/components/steps/wohnung/WohnungStep9.vue';
import WohnungStep10 from '@/components/steps/wohnung/WohnungStep10.vue';

import WohnungStep11a from '@/components/steps/wohnung/WohnungStep11a.vue';
import WohnungStep11b from '@/components/steps/wohnung/WohnungStep11b.vue';
import WohnungStep11c from '@/components/steps/wohnung/WohnungStep11c.vue';
import DgWohnungStep1 from '@/components/steps/dg-wohnung/DgWohnungStep1.vue';
import DgWohnungStep2 from '@/components/steps/dg-wohnung/DgWohnungStep2.vue';
import DgWohnungStep3 from '@/components/steps/dg-wohnung/DgWohnungStep3.vue';
import DgWohnungStep4 from '@/components/steps/dg-wohnung/DgWohnungStep4.vue';
import DgWohnungStep5 from '@/components/steps/dg-wohnung/DgWohnungStep5.vue';
import DgWohnungStep6 from '@/components/steps/dg-wohnung/DgWohnungStep6.vue';
import DgWohnungStep8a from '@/components/steps/dg-wohnung/DgWohnungStep8a.vue';
import DgWohnungStep8b from '@/components/steps/dg-wohnung/DgWohnungStep8b.vue';
import DgWohnungStep7 from '@/components/steps/dg-wohnung/DgWohnungStep7.vue';
import DgWohnungStep9 from '@/components/steps/dg-wohnung/DgWohnungStep9.vue';
import DgWohnungStep10 from '@/components/steps/dg-wohnung/DgWohnungStep10.vue';
import DgWohnungStep11a from '@/components/steps/dg-wohnung/DgWohnungStep11a.vue';
import DgWohnungStep11b from '@/components/steps/dg-wohnung/DgWohnungStep11b.vue';
import DgWohnungStep11c from '@/components/steps/dg-wohnung/DgWohnungStep11c.vue';
import BaugrundstueckStep1 from '@/components/steps/baugrundstueck/BaugrundstueckStep1.vue';
import BaugrundstueckStep2 from '@/components/steps/baugrundstueck/BaugrundstueckStep2.vue';
import BaugrundstueckStep3 from '@/components/steps/baugrundstueck/BaugrundstueckStep3.vue';
import BaugrundstueckStep4 from '@/components/steps/baugrundstueck/BaugrundstueckStep4.vue';
import BaugrundstueckStep5a from '@/components/steps/baugrundstueck/BaugrundstueckStep5a.vue';
import BaugrundstueckStep5b from '@/components/steps/baugrundstueck/BaugrundstueckStep5b.vue';
import BaugrundstueckStep5c from '@/components/steps/baugrundstueck/BaugrundstueckStep5c.vue';
import ReihenhausStep1 from '@/components/steps/reihenhaus/ReihenhausStep1.vue';
import ReihenhausStep2 from '@/components/steps/reihenhaus/ReihenhausStep2.vue';
import ReihenhausStep3 from '@/components/steps/reihenhaus/ReihenhausStep3.vue';
import ReihenhausStep4 from '@/components/steps/reihenhaus/ReihenhausStep4.vue';
import ReihenhausStep5 from '@/components/steps/reihenhaus/ReihenhausStep5.vue';
import ReihenhausStep6 from '@/components/steps/reihenhaus/ReihenhausStep6.vue';
import ReihenhausStep7 from '@/components/steps/reihenhaus/ReihenhausStep7.vue';
import ReihenhausStep8a from '@/components/steps/reihenhaus/ReihenhausStep8a.vue';
import ReihenhausStep8b from '@/components/steps/reihenhaus/ReihenhausStep8b.vue';
import ReihenhausStep9 from '@/components/steps/reihenhaus/ReihenhausStep9.vue';
import ReihenhausStep10 from '@/components/steps/reihenhaus/ReihenhausStep10.vue';
import ReihenhausStep11a from '@/components/steps/reihenhaus/ReihenhausStep11a.vue';
import ReihenhausStep11b from '@/components/steps/reihenhaus/ReihenhausStep11b.vue';
import ReihenhausStep11c from '@/components/steps/reihenhaus/ReihenhausStep11c.vue';

const routes = [
  { path: '/', alias: '/start', name: 'Start', component: StartStep },
  { path: '/haus-step-1', name: 'HausStep1', component: HausStep1 },
  { path: '/haus-step-2', name: 'HausStep2', component: HausStep2 },
  { path: '/haus-step-3', name: 'HausStep3', component: HausStep3 },
  { path: '/haus-step-4', name: 'HausStep4', component: HausStep4 },
  { path: '/haus-step-5', name: 'HausStep5', component: HausStep5 },
  { path: '/haus-step-6', name: 'HausStep6', component: HausStep6 },
  { path: '/haus-step-7', name: 'HausStep7', component: HausStep7 },

  { path: '/haus-step-8a', name: 'HausStep8a', component: HausStep8a },
  { path: '/haus-step-8b', name: 'HausStep8b', component: HausStep8b },
  { path: '/haus-step-7', name: 'HausStep7', component: HausStep7 },
  { path: '/haus-step-9', name: 'HausStep9', component: HausStep9 },
  { path: '/haus-step-10', name: 'HausStep10', component: HausStep10 },
  { path: '/haus-step-11a', name: 'HausStep11a', component: HausStep11a },
  { path: '/haus-step-11b', name: 'HausStep11b', component: HausStep11b },
  { path: '/haus-step-11c', name: 'HausStep11c', component: HausStep11c },
  { path: '/wohnung-step-1', name: 'WohnungStep1', component: WohnungStep1 },
  { path: '/wohnung-step-2', name: 'WohnungStep2', component: WohnungStep2 },
  { path: '/wohnung-step-3', name: 'WohnungStep3', component: WohnungStep3 },
  { path: '/wohnung-step-4', name: 'WohnungStep4', component: WohnungStep4 },
  { path: '/wohnung-step-5', name: 'WohnungStep5', component: WohnungStep5 },
  { path: '/wohnung-step-6', name: 'WohnungStep6', component: WohnungStep6 },
  { path: '/wohnung-step-7', name: 'WohnungStep7', component: WohnungStep7 },
  { path: '/wohnung-step-8b', name: 'WohnungStep8b', component: WohnungStep8b },
  { path: '/wohnung-step-8a', name: 'WohnungStep8a', component: WohnungStep8a },
  { path: '/wohnung-step-9', name: 'WohnungStep9', component: WohnungStep9 },
  { path: '/wohnung-step-10', name: 'WohnungStep10', component: WohnungStep10 },

  {
    path: '/wohnung-step-11a',
    name: 'WohnungStep11a',
    component: WohnungStep11a,
  },
  {
    path: '/wohnung-step-11b',
    name: 'WohnungStep11b',
    component: WohnungStep11b,
  },
  {
    path: '/wohnung-step-11c',
    name: 'WohnungStep11c',
    component: WohnungStep11c,
  },
  {
    path: '/dg-wohnung-step-1',
    name: 'DgWohnungStep1',
    component: DgWohnungStep1,
  },
  {
    path: '/dg-wohnung-step-2',
    name: 'DgWohnungStep2',
    component: DgWohnungStep2,
  },
  {
    path: '/dg-wohnung-step-3',
    name: 'DgWohnungStep3',
    component: DgWohnungStep3,
  },
  {
    path: '/dg-wohnung-step-4',
    name: 'DgWohnungStep4',
    component: DgWohnungStep4,
  },
  {
    path: '/dg-wohnung-step-5',
    name: 'DgWohnungStep5',
    component: DgWohnungStep5,
  },
  {
    path: '/dg-wohnung-step-6',
    name: 'DgWohnungStep6',
    component: DgWohnungStep6,
  },
  {
    path: '/dg-wohnung-step-8a',
    name: 'DgWohnungStep8a',
    component: DgWohnungStep8a,
  },
  {
    path: '/dg-wohnung-step-8b',
    name: 'DgWohnungStep8b',
    component: DgWohnungStep8b,
  },
  {
    path: '/dg-wohnung-step-7',
    name: 'DgWohnungStep7',
    component: DgWohnungStep7,
  },
  {
    path: '/dg-wohnung-step-9',
    name: 'DgWohnungStep9',
    component: DgWohnungStep9,
  },
  {
    path: '/dg-wohnung-step-10',
    name: 'DgWohnungStep10',
    component: DgWohnungStep10,
  },
  {
    path: '/dg-wohnung-step-11a',
    name: 'DgWohnungStep11a',
    component: DgWohnungStep11a,
  },
  {
    path: '/dg-wohnung-step-11b',
    name: 'DgWohnungStep11b',
    component: DgWohnungStep11b,
  },
  {
    path: '/dg-wohnung-step-11c',
    name: 'DgWohnungStep11c',
    component: DgWohnungStep11c,
  },
  {
    path: '/reihenhaus-step-1',
    name: 'ReihenhausStep1',
    component: ReihenhausStep1,
  },
  {
    path: '/reihenhaus-step-2',
    name: 'ReihenhausStep2',
    component: ReihenhausStep2,
  },
  {
    path: '/reihenhaus-step-3',
    name: 'ReihenhausStep3',
    component: ReihenhausStep3,
  },
  {
    path: '/reihenhaus-step-4',
    name: 'ReihenhausStep4',
    component: ReihenhausStep4,
  },
  {
    path: '/reihenhaus-step-5',
    name: 'ReihenhausStep5',
    component: ReihenhausStep5,
  },
  {
    path: '/reihenhaus-step-6',
    name: 'ReihenhausStep6',
    component: ReihenhausStep6,
  },
  {
    path: '/reihenhaus-step-7',
    name: 'ReihenhausStep7',
    component: ReihenhausStep7,
  },
  {
    path: '/reihenhaus-step-8a',
    name: 'ReihenhausStep8a',
    component: ReihenhausStep8a,
  },
  {
    path: '/reihenhaus-step-8b',
    name: 'ReihenhausStep8b',
    component: ReihenhausStep8b,
  },
  {
    path: '/reihenhaus-step-9',
    name: 'ReihenhausStep9',
    component: ReihenhausStep9,
  },
  {
    path: '/reihenhaus-step-10',
    name: 'ReihenhausStep10',
    component: ReihenhausStep10,
  },
  {
    path: '/reihenhaus-step-11a',
    name: 'ReihenhausStep11a',
    component: ReihenhausStep11a,
  },
  {
    path: '/reihenhaus-step-11b',
    name: 'ReihenhausStep11b',
    component: ReihenhausStep11b,
  },
  {
    path: '/reihenhaus-step-11c',
    name: 'ReihenhausStep11c',
    component: ReihenhausStep11c,
  },
  {
    path: '/baugrundstueck-step-1',
    name: 'BaugrundstueckStep1',
    component: BaugrundstueckStep1,
  },
  {
    path: '/baugrundstueck-step-2',
    name: 'BaugrundstueckStep2',
    component: BaugrundstueckStep2,
  },
  {
    path: '/baugrundstueck-step-3',
    name: 'BaugrundstueckStep3',
    component: BaugrundstueckStep3,
  },
  {
    path: '/baugrundstueck-step-4',
    name: 'BaugrundstueckStep4',
    component: BaugrundstueckStep4,
  },
  {
    path: '/baugrundstueck-step-5a',
    name: 'BaugrundstueckStep5a',
    component: BaugrundstueckStep5a,
  },
  {
    path: '/baugrundstueck-step-5b',
    name: 'BaugrundstueckStep5b',
    component: BaugrundstueckStep5b,
  },
  {
    path: '/baugrundstueck-step-5c',
    name: 'BaugrundstueckStep5c',
    component: BaugrundstueckStep5c,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

let historyPath = '/price-indicator';

if (process.env.VUE_APP_DEPLOYMENT === 'production') {
  historyPath = 'erstebank/deaktiv/k25/price-indicator';
}

const router = createRouter({
  history: createWebHashHistory(historyPath),
  routes,
  scrollBehavior() {
    {
      return {
        el: '.scrollPosition',
        top: 95,
        behavior: 'smooth',
      };
    }
  },
});

export default router;
